import { Grid, Typography, Accordion, AccordionSummary, AccordionDetails } from '@material-ui/core';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import PropTypes from 'prop-types';
import React from 'react';

import { VMSize } from './VMSize';

VMResourceSettings.propTypes = {
  currentVM: PropTypes.object,
  updateCurrentVM: PropTypes.func
};

export function VMResourceSettings({ currentVM, updateCurrentVM }) {
  return (
    <Grid item xs={12}>
      <Accordion>
        <AccordionSummary sx={{ paddingLeft: 0 }} expandIcon={<ExpandMoreIcon />}>
          <Typography variant="h6">Resource Settings</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <VMSize currentVM={currentVM} updateCurrentVM={updateCurrentVM} />
        </AccordionDetails>
      </Accordion>
    </Grid>
  );
}
